import { CadastralData } from '../../models/appraisal.model';

const mapCadastralData = (
  catastralRefs: Array<{
    cadastralRef: string;
    propertyType: string;
    propertyRegistry: {
      registry: string;
      registryNumber: string;
      farmNumber: string;
      volume: string;
      book: string;
      folio: string;
    };
    idufir: string;
  }>,
) => {
  const catastralFinalArray: Array<CadastralData> = [];
  for (const catastralRef in catastralRefs) {
    catastralFinalArray.push({
      reference: catastralRefs[catastralRef].cadastralRef,
      typeAsset: catastralRefs[catastralRef].propertyType,
      propertyRegistry: catastralRefs[catastralRef].propertyRegistry,
      idufir: catastralRefs[catastralRef].idufir,
    });
  }
  return catastralFinalArray;
};

export const mapMortgageAppraisal = (mortgageAppraisalData, appraisal) => {
  return {
    simpleNote: appraisal.mortgagesAppraisalData.simpleNote,
    appraisal: appraisal.mortgagesAppraisalData.appraisal,
    appraisalAmount: appraisal.mortgagesAppraisalData.appraisalAmount,
    appraisalCost: appraisal.mortgagesAppraisalData.appraisalCost,
    appraisalAddress: {
      roadType: mortgageAppraisalData.streetType,
      roadName: mortgageAppraisalData.street,
      roadNumber: mortgageAppraisalData.number,
      floor: mortgageAppraisalData.flat,
      door: mortgageAppraisalData.door,
      zip: mortgageAppraisalData.postalCode,
      city: mortgageAppraisalData.location,
      province: mortgageAppraisalData.province,
      otherLocation: mortgageAppraisalData.otherLocation,
    },
    cadastralData: mortgageAppraisalData.catastralRefs,
    nameCurrentOwner: mortgageAppraisalData.name,
    phoneCurrentOwner: mortgageAppraisalData.phone,
  };
};

export const mapMortgageAppraisalFileRequest = (appraisal) => {
  return {
    simpleNote: appraisal.mortgagesAppraisalData.simpleNote,
    appraisal: appraisal.mortgagesAppraisalData.appraisal,
    appraisalAmount: appraisal.mortgagesAppraisalData.appraisalAmount,
    appraisalCost: appraisal.mortgagesAppraisalData.appraisalCost,
    appraisalAddress: {
      roadType: '',
      roadName: '',
      roadNumber: '',
      floor: '',
      door: '',
      zip: '',
      city: '',
      province: '',
      otherLocation: '',
    },
    cadastralData: [],
    nameCurrentOwner: '',
    phoneCurrentOwner: '',
  };
};

export const mapAppraisal = (appraisal) => {
  return {
    streetType: appraisal.mortgagesAppraisalData.appraisalAddress.roadType,
    street: appraisal.mortgagesAppraisalData.appraisalAddress.roadName,
    number: appraisal.mortgagesAppraisalData.appraisalAddress.roadNumber,
    flat: appraisal.mortgagesAppraisalData.appraisalAddress.floor,
    door: appraisal.mortgagesAppraisalData.appraisalAddress.door,
    postalCode: appraisal.mortgagesAppraisalData.appraisalAddress.zip,
    location: appraisal.mortgagesAppraisalData.appraisalAddress.city,
    province: appraisal.mortgagesAppraisalData.appraisalAddress.province,
    name: appraisal.mortgagesAppraisalData.nameCurrentOwner,
    phone: appraisal.mortgagesAppraisalData.phoneCurrentOwner,
    otherLocation: appraisal.mortgagesAppraisalData.appraisalAddress.otherLocation,
  };
};
